import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, HomeIcon, MessageCircle } from "lucide-react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import ODOCreateForm from "../../components/cs/ODOCreateForm";

const ODOCreate = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/cs", {
      state: { activeTab: "odo" },
      replace: true,
    });
  };

  const handleCancel = () => {
    navigate("/cs", {
      state: { activeTab: "odo" },
      replace: true,
    });
  };

  return (
    <>
      <Header />
      <main className="mx-auto py-[64px] md:py-[100px] px-5 md:px-6 relative max-w-4xl mb-[100px] font-serif-kr">
        <div className="mb-6">
          <div className="flex items-center gap-4 px-2">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2 text-gray-900 hover:text-purple-500 hover:underline transition-colors"
            >
              <HomeIcon className="w-4 h-4" />
              <span>홈</span>
            </button>
            <span className="text-gray-400">|</span>
            <button
              onClick={handleCancel}
              className="flex items-center gap-2 text-gray-900 hover:text-blue-500 hover:underline transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              <span>고객센터</span>
            </button>
          </div>
        </div>

        <div className="text-center mb-6 bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-xl p-6">
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center mb-4">
              <FileText className="w-10 h-10 text-green-600 mr-3" />
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                1:1 문의하기
              </h1>
            </div>

            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              궁금한 점이나 문제가 있으시면 언제든 문의해주세요.
              <br className="hidden sm:block" />
              빠르고 정확한 답변으로 도움을 드리겠습니다.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <ODOCreateForm onSuccess={handleSuccess} onCancel={handleCancel} />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ODOCreate;
